var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emoji") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Outside-Incoming-call---Cancel",
    transform: "translate(-419.000000, -1070.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(17.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(381.000000, 860.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Like---green",
    transform: "translate(20.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "happy-(1)",
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.000000, 13.000000) scale(-1, 1) rotate(-180.000000) translate(-13.000000, -13.000000) ",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.9746341,13.0126829 C25.9746341,5.84010732 20.1598927,0.0253658537 12.9873171,0.0253658537 C5.81474146,0.0253658537 0,5.84010732 0,13.0126829 C0,20.1852585 5.81474146,26 12.9873171,26 C20.1598927,26 25.9746341,20.1852585 25.9746341,13.0126829",
    id: "Shape",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9873171,10.8481512 C10.373239,10.8481512 8.63872195,11.1526049 6.49365854,11.5696829 C6.00371707,11.6641707 5.05059512,11.5696829 5.05059512,10.1266195 C5.05059512,7.2405561 8.36597561,3.63296098 12.9873171,3.63296098 C17.6078976,3.63296098 20.924039,7.2405561 20.924039,10.1266195 C20.924039,11.5696829 19.9709171,11.6648683 19.4809756,11.5696829 C17.3359122,11.1526049 15.6013951,10.8481512 12.9873171,10.8481512",
    id: "Shape",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49365854,10.1266195 C6.49365854,10.1266195 8.65819024,9.4050878 12.9873171,9.4050878 C17.3164439,9.4050878 19.4809756,10.1266195 19.4809756,10.1266195 C19.4809756,10.1266195 18.0379122,7.2405561 12.9873171,7.2405561 C7.93672195,7.2405561 6.49365854,10.1266195 6.49365854,10.1266195",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4620195,16.2595122 C10.4620195,14.8640732 9.65462439,13.7342146 8.65825366,13.7342146 C7.66188293,13.7342146 6.8544878,14.8641366 6.8544878,16.2595122 C6.8544878,17.6541902 7.66188293,18.7848098 8.65825366,18.7848098 C9.65462439,18.7848098 10.4620195,17.6541902 10.4620195,16.2595122",
    id: "SVGCleanerId_0",
    fill: "#664500"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.234146, 13.697561)",
    fill: "#664500",
    id: "SVGCleanerId_0_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.64703902,2.56195122 C3.64703902,1.1665122 2.8396439,0.0366536585 1.84327317,0.0366536585 C0.846902439,0.0366536585 0.0395073171,1.16657561 0.0395073171,2.56195122 C0.0395073171,3.95662927 0.846902439,5.08724878 1.84327317,5.08724878 C2.8396439,5.08724878 3.64703902,3.95662927 3.64703902,2.56195122"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.0d80f49c8533b457a387bf36e7df2df2.svg";
export { ForwardRef as ReactComponent };